// Layout
import { MainLayout } from "@/components/reusable_components/next"

// Purchase
import ProviderRoutes from "./Purchase/PchProvider"
import PurchaseInvoiceRoutes from "./Purchase/PchPurchaseInvoice"
import PurchaseOrderRoutes from "./Purchase/PchPurchaseOrder"
import PchPurchaseOrderEditedRoutes from "./Purchase/PchPurchaseOrderEdited"
import PurchaseQuotationRoutes from "./Purchase/PchPurchaseQuotation"

// Warehouse
import OrdererRoutes from "./Warehouse/WhOrderer"

// Index view
import IndexView from "@/views/Index"

/**
 * @description
 * 
 */
export default [
    {
        path: "/",
        component: MainLayout,
        props: {
            breadcrumbsProps: {
                indexText: "Adquisiciones",
            }
        },
        children: [

            // Index
            {
                path: "",
                name: "index",
                component: IndexView,
            },

            // Purchase
            ProviderRoutes,
            PurchaseInvoiceRoutes,
            PurchaseOrderRoutes,
            PchPurchaseOrderEditedRoutes,
            PurchaseQuotationRoutes,

            //Warehouse
            OrdererRoutes,
        ],
    },
]
